module.exports = __webpack_public_path__ + "img/banner.f9376b73.png";